export class SIQChatFormTheme {
  backgroundColor = "null";
  textFieldBackgroundColor = "null";
  textFieldTextColor = "null";
  textFieldTintColor = "null";
  textFieldPlaceholderColor = "null";
  textFieldTitleColor = "null";
  textFieldRequiredIndicatorColor = "null";
  errorColor = "null";
  submitButtonBackgroundColor = "null";
  submitButtonTextColor = "null";
  campaignOptInTextColor = "null";
  checkboxCheckedColor = "null";
  checkboxUncheckedColor = "null";
}
//# sourceMappingURL=SIQChatFormTheme.js.map